import React from "react";

function ContactMe() {
  return (
    <div className="contact-section">
      <div className="contact-inner">
        <div className="section-header">
          <div className="section-label">Let's talk</div>
          <h2 className="section-title light">Get in touch</h2>
        </div>

        <p>
          I'm currently open to frontend and full stack roles. Whether you have
          a position in mind or just want to connect — my inbox is always open.
        </p>

        <a href="mailto:jibodu.busola@gmail.com" className="contact-email-link">
          ✉ busola.ilechukwu@gmail.com
        </a>

        <div className="contact-socials">
          <a
            href="https://github.com/beejay321"
            target="_blank"
            rel="noreferrer"
            className="contact-social-link"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/oluwabusola-jibodu-869418125/"
            target="_blank"
            rel="noreferrer"
            className="contact-social-link"
          >
            LinkedIn
          </a>
          <a
            href="https://docs.google.com/document/d/1eHAUsdxh8J53QIvTRZA6ZmZHbiwiTMUaqt-bCDyoVdI/edit?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="contact-social-link"
          >
            Resume ↗
          </a>
        </div>
      </div>

      <footer className="site-footer">
        <p>
          Designed & built by{" "}
          <a
            href="https://github.com/beejay321"
            target="_blank"
            rel="noreferrer"
          >
            Oluwabusola Ilechukwu
          </a>{" "}
          · {new Date().getFullYear()}
        </p>
      </footer>
    </div>
  );
}

export default ContactMe;
